import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
  Paper,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import AOS from 'aos';
import 'aos/dist/aos.css';

const PartnersSection = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isRTL = i18n.dir() === 'rtl';

  // Font family logic
  const fontFamily = isRTL
    ? "'Tajawal', Arial, sans-serif"
    : "Arial, Helvetica, sans-serif";

  const textStyle = {
    fontSize: '3rem',
    color: '#fff',
    textShadow:
      '0 0 5px rgb(0, 162, 255), 0 0 10px rgb(36, 60, 196), 0 0 20px rgb(34, 130, 185), 0 0 40px rgb(28, 86, 161), 0 0 80px rgb(214, 187, 197)',
    animation: 'glow 1.5s infinite alternate',
    fontFamily,
  };

  const partners = [
    {
      name: t("part1"),
      logo: '/images/ksu.png',
      alt: 'King Saud University Logo',
    },
    {
      name: t("part2"),
      logo: '/images/Qul.jpg',
      alt: 'Qassim University Logo',
    },
    {
      name: t("part3"),
      logo: '/images/MOHL.jpeg',
      alt: 'Ministry of Health Logo',
    },
  ];

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <Box
      sx={{
        py: 8,
        px: 2,
      
        direction: isRTL ? 'rtl' : 'ltr',
        fontFamily,
      }}
    >
      <Box sx={{ maxWidth: 1200, mx: 'auto', textAlign: 'center' }}>
        <style>
          {`
            @keyframes glow {
              0% {
                text-shadow: 0 0 5px rgb(0, 153, 255), 0 0 10px #0C2182, 0 0 20px #0C2182, 0 0 40px #0C2182;
              }
              100% {
                text-shadow: 0 0 10px #0C2182, 0 0 20px #0C2182, 0 0 40px #0C2182, 0 0 80px #0C2182;
              }
            }
          `}
        </style>

        <Typography
          component="h1"
          variant={isMobile ? 'h5' : 'h3'}
          sx={{
            fontWeight: 'bold',
            color: '#0C2182',
            mb: 6,
            paddingBottom: '20px',
            letterSpacing: 1,
            ...textStyle,
          }}
        >
          {t('ourpartner')}
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {partners.map((partner, index) => (
            <Grid item xs={12} sm={6} md={4} key={index} data-aos="zoom-in-up">
              <Paper
                elevation={6}
                sx={{
                  height: '80%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  p: 3,
                  borderRadius: 4,
                  textAlign: 'center',
                  backdropFilter: 'blur(10px)',
                  backgroundColor: 'rgba(255, 255, 255, 0.75)',
                  transition: '0.3s',
                  fontFamily,
                  '&:hover': {
                    transform: 'scale(1.03)',
                    boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
                  },
                }}
              >
                <Box
                  sx={{
                    minHeight: 180,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 0,
                    backgroundColor: '#fff',
                    borderRadius: 2,
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
                  }}
                >
                  <Box
                    component="img"
                    src={partner.logo}
                    alt={partner.alt}
                    sx={{
                      maxHeight: 140,
                      maxWidth: '100%',
                      objectFit: 'contain',
                      p: 1,
                    }}
                  />
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: '#0C2182',
                    fontFamily,
                  }}
                >
                  {partner.name}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default PartnersSection;
